// PreviewJob/PreviewCodeSettingコンポーネントを流用するため
// 子コンポーネントに合わせた形式で変換する。

// コード設定表では、通常求人（PreviewOfferCodeSettingForm）と同様に
// 未設定の項目でも「指定しない」を表示する。
const UNSPECIFIED_LABEL = '指定しない'

export const toJobInfo = (clientJob) => {
  return {
    ...clientJob,
    employmentStatus: [clientJob.employmentStatus],
    salaryMap: clientJob.isSalaryDisplay ? clientJob.salaryMap : null,
    isSalaryDisplay: clientJob.isSalaryDisplay,
    salesStyle: { value: '' },
    merchandiseDeal: { value: '' },
    careerPath: { value: '' },
    supportAfterJoin: { value: '' },
    welcomeSkill: { value: '' },
    recruitExample: { value: '' },
    salaryExample: { value: '' },
    bonus: { value: '' },
    overTime: { value: '' },
    transportation: { value: '' },
    workstyleNote: { value: '' },
    maternityChildcare: { value: '' },
    attentionPointCaption1: { value: '' },
    attentionPointCaption2: { value: '' },
    timeScheduleTitle: { value: '' }
  }
}

export const defaultCompanyInterview = {
  topicsTitle1: { value: '' },
  topicsTitle2: { value: '' },
  interviewBody: { value: '' }
}

export const toCompanyInfo = (clientJob) => {
  return {
    companyName: clientJob.companyName,
    companyDescription: clientJob.companyDescription,
    mediaCoverage: { value: '' },
    mainClient: { value: '' },
    established: { value: '' },
    employeesNum: { value: '' },
    averageAge: { value: '' },
    employeesSexRatio: { value: '' },
    middleEnterRatio: { value: '' },
    capital: { value: '' },
    salesAmount: { value: '' },
    presidentName: { value: '' },
    presidentHistory: { value: '' }
  }
}

export const toAboutApply = (clientJob) => {
  return {
    entryProcess: {
      processes: clientJob.processes,
      processDetail: { value: '' }
    },
    zipcode: clientJob.zipcode,
    address: clientJob.address,
    tel: clientJob.tel,
    contactEmail: clientJob.contactEmail,
    contactDepartment: { value: '' },
    links: []
  }
}

export const toCodeSetting = (clientJob) => {
  return {
    businesses: clientJob.businesses,
    primaryOfferJobName: clientJob.primaryOfferJobName,
    employments: [clientJob.employmentStatus],
    salaryMap: clientJob.salaryMap,
    isSalaryDisplay: clientJob.isSalaryDisplay,
    workplaceNameList: clientJob.workplaceNameList,
    workstyle: clientJob.workstyle || UNSPECIFIED_LABEL,
    overtimeWorkHours: clientJob.overtimeWorkHours || UNSPECIFIED_LABEL,
    prCodes: clientJob.prCodes,
    offerJobCodeTypeForm: { hasOfferJobCodeSet: false },
    companyStaffs: []
  }
}
